import { HomeItems } from './components/HomePage/items';
import { FE1Items } from './components/Module/FE1/items';
import { FE2Items } from './components/Module/FE2/items';
import { FE3Items } from './components/Module/FE3/items';
import { FE4Items } from './components/Module/FE4/items';
import { FE5Items } from './components/Module/FE5/items';
import { FE6Items } from './components/Module/FE6/items';
import { FE7Items } from './components/Module/FE7/items';
import { FE8Items } from './components/Module/FE8/items';
import { FE10Items } from './components/Module/FE10/items';
import { FE11Items } from './components/Module/FE11/items';
import { FE12Items } from './components/Module/FE12/items';

export const items = [
  HomeItems,
  FE1Items,
  FE2Items,
  FE3Items,
  FE4Items,
  FE5Items,
  FE6Items,
  FE7Items,
  FE8Items,
  FE10Items,
  FE11Items,
  FE12Items,
];

export default items;
